import React from "react";
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";

interface PayPalPaymentHandlerProps {
  amount: number;
  orderData: any;
  onSuccess: (details: any) => void;
  onError: (error: any) => void;
  onCancel: () => void;
}

const PayPalPaymentHandler: React.FC<PayPalPaymentHandlerProps> = ({
  amount,
  orderData,
  onSuccess,
  onError,
  onCancel,
}) => {
  const [{ isPending }] = usePayPalScriptReducer();

  return (
    <div className="paypal-button-container">
      {isPending ? (
        <div className="loading-spinner">Cargando opciones de pago...</div>
      ) : (
        <PayPalButtons
          createOrder={(data, actions) => {
            return actions.order.create({
              intent: "CAPTURE",
              purchase_units: [
                {
                  description: `Orden #${orderData.id || "nueva"}`,
                  amount: {
                    currency_code: "MXN",
                    value: amount.toString(),
                  },
                },
              ],
            });
          }}
          onApprove={async (data, actions) => {
            if (actions.order) {
              const details = await actions.order.capture();
              onSuccess(details);
            }
          }}
          onError={(err) => {
            console.error("PayPal Error:", err);
            onError(err);
          }}
          onCancel={() => {
            onCancel();
          }}
          style={{
            layout: "vertical",
            color: "blue",
            shape: "rect",
            label: "pay",
          }}
        />
      )}
    </div>
  );
};

export default PayPalPaymentHandler;
